export default __webpack_public_path__ + "static/media/uploadfile.67f8ce4a.svg";